/** Matches Scoreboard tab state in Scoreboard.tsx */
export enum ScoreboardTab {
  Campuses = 'campuses',
  Participants = 'participants',
  Teams = 'teams',
  HealthSystems = 'healthSystems'
}

export type ScoreboardChartView = 'department' | 'division' | 'participant';

export const chartViewForScoreboardTab = (tab: ScoreboardTab): ScoreboardChartView => {
  switch (tab) {
    case ScoreboardTab.Participants:
      return 'participant';
    case ScoreboardTab.Teams:
      return 'division';
    case ScoreboardTab.Campuses:
    default:
      return 'department';
  }
};

export const SCOREBOARD_TREND_TOP_N = 10;
